import React from 'react'
import styles from './StatusIcon.module.css'

const SuccessStatusIcon = () => (
    <div className={styles.iconWrapper}>
        <div className={`${styles.icon} ${styles.iconSuccess}`}>✓</div>
    </div>
)

export default SuccessStatusIcon
